"use client";

import { isClient } from "./is-client";

/**
 * dispatchCustomEvent
 * @returns window.dispatchEvent(new CustomEvent(name))
 * @example
 * onClick={()=> dispatchCustomEvent('my-modal')}
 */
export const dispatchCustomEvent = (name: string, detail?: object) =>
  isClient() && window.dispatchEvent(new CustomEvent(name, { detail }));
